import { StringKey } from '../../../../../lang/index';

export enum Column {
  ACTIONS = 'actions',
  CATEGORY = 'category',
  EDITED_ON = 'edited-on',
  NAME = 'name',
  SIGNATORIES = 'signatories',
  STATUS = 'status',
}

export const columnTitleMap: Record<Column, StringKey> = {
  [Column.NAME]: 'NAME',
  [Column.CATEGORY]: 'CATEGORY',
  [Column.STATUS]: 'STATUS',
  [Column.SIGNATORIES]: 'SIGNATORIES',
  [Column.EDITED_ON]: 'EDITED_ON',
  [Column.ACTIONS]: 'EMPTY',
};

export const columnOrderMap = Object.keys(columnTitleMap) as Column[];
